module.exports = __webpack_public_path__ + "img/icon_check.91830c2d.svg";